import { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import SubHeader from '../header/SubHeader.react';
import MobileMenu from '../mobile-menu/MobileMenu.react';
var NavigationMobile = function NavigationMobile(_ref) {
  var navigationAction = _ref.navigationAction;
  var navArr = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  useEffect(function () {
    navigationAction({});
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubHeader, {
    route: "desktop-navigation"
  }), /*#__PURE__*/React.createElement(MobileMenu, {
    navArr: navArr
  }));
};
var mdtp = {
  navigationAction: cmsActions.navigation
};
export default connect(null, mdtp)(NavigationMobile);